import _ from 'lodash';

export const composeBarChartData = (data, fields, labelField, labelSuffix) =>
  fields.map(field =>
    data.map(row => ({
      x: row[labelField],
      y: row[field],
      label: labelSuffix ? `${row[field]} ${labelSuffix}` : row[field],
    })));

export const formatLabels = (data, label) => _.map(data, (row) => {
  const check = row[label];
  return `${check}`;
});

const resdit = {
  title: 'RESDIT 74 / 21',
  type: 'groupedBar',
  fields: [{
    name: '74',
    color: '#5B9BD5',
  }, {
    name: '21',
    color: '#1F4E79',
  }],
  yTickFormat: tick => `${tick} %`,
  xTickValues: data => formatLabels(data, 'carrier'),
  composeChartData: data => composeBarChartData(
    data,
    ['resdit.resdit74', 'resdit.resdit21'],
    'carrier',
    '%',
  ),
};

const nesting = {
  title: 'Nesting',
  type: 'groupedBar',
  fields: [{
    name: 'CJID',
    color: '#5B9BD5',
  }, {
    name: 'ULD ID',
    color: '#1F4E79',
  }],
  yTickFormat: tick => `${tick} %`,
  xTickValues: data => formatLabels(data, 'carrier'),
  composeChartData: data => composeBarChartData(
    data,
    ['nesting.cjid', 'nesting.uldId'],
    'carrier',
    '%',
  ),
};

const criticalElements = {
  title: 'Critical Elements',
  type: 'groupedBar',
  fields: [{
    name: 'LHOT origin',
    color: '#1F4E79',
  }, {
    name: 'LHOT destination',
    color: '#5B9BD5',
  }, {
    name: 'Contract reference',
    color: '#d57323',
  }, {
    name: 'Booking reference (PAWB)',
    color: '#d3d538',
  }],
  yTickFormat: tick => `${tick} %`,
  xTickValues: data => formatLabels(data, 'carrier'),
  composeChartData: data => composeBarChartData(
    data,
    [
      'criticalElements.lhotOrigin',
      'criticalElements.lhotDestination',
      'criticalElements.contractReference',
      'criticalElements.bookingReference',
    ],
    'carrier',
    '%',
  ),
};

const carditTimeliness = {
  title: 'CARDIT Timeliness',
  type: 'groupedBar',
  fields: [{
    name: 'On time',
    color: '#5B9BD5',
  }],
  yTickFormat: tick => `${tick} %`,
  xTickValues: data => formatLabels(data, 'carrier'),
  composeChartData: data => composeBarChartData(
    data,
    ['cardit.onTime'],
    'carrier',
    '%',
  ),
};

export default {
  resdit,
  nesting,
  criticalElements,
  carditTimeliness,
};
